module.exports = __webpack_public_path__ + "images/bug_purple_size_5_562f954ac88e4521c0770bf06c188e7b.png";